import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import MultiChannelCampaignsAPI from '../../api/multiChannelCampaigns';

const SET_UI_FLAG = 'SET_MC_CAMPAIGN_UI_FLAG';
const SET_CAMPAIGNS = 'SET_MC_CAMPAIGNS';
const ADD_CAMPAIGN = 'ADD_MC_CAMPAIGN';
const DELETE_CAMPAIGN = 'DELETE_MC_CAMPAIGN';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getCampaigns(_state) {
    return _state.records;
  },
};

export const actions = {
  get: async ({ commit }) => {
    commit(SET_UI_FLAG, { isFetching: true });
    try {
      const response = await MultiChannelCampaignsAPI.get();
      commit(SET_CAMPAIGNS, response.data);
    } catch (error) {
      // ignore
    } finally {
      commit(SET_UI_FLAG, { isFetching: false });
    }
  },
  create: async ({ commit }, campaignObj) => {
    commit(SET_UI_FLAG, { isCreating: true });
    try {
      const response = await MultiChannelCampaignsAPI.create(campaignObj);
      commit(ADD_CAMPAIGN, response.data);
      return response.data;
    } finally {
      commit(SET_UI_FLAG, { isCreating: false });
    }
  },
  delete: async ({ commit }, id) => {
    try {
      await MultiChannelCampaignsAPI.delete(id);
      commit(DELETE_CAMPAIGN, id);
    } catch (error) {
      throw new Error(error);
    }
  },
};

export const mutations = {
  [SET_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  [SET_CAMPAIGNS]: MutationHelpers.set,
  [ADD_CAMPAIGN]: MutationHelpers.create,
  [DELETE_CAMPAIGN]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
